export const deleteActionTypes = {
    DELETE_ITEMS_START: "DELETE_ITEMS_START",
    DELETE_ITEMS_SUCCESS: "DELETE_ITEMS_SUCCESS",
    DELETE_ITEMS_FAILURE: "DELETE_ITEMS_FAILURE",
    SET_DELETED_ITEMS: "SET_DELETED_ITEMS",
    SET_IS_FAIL: "SET_IS_FAIL",
    REMOVE_DELETED_ITEMS: "REMOVE_DELETED_ITEMS"
}